// Utility function to format prices with naira symbol and commas
export const formatPrice = (price) => {
  if (!price || isNaN(price)) return '₦0';
  
  // Convert to number and format with commas
  const numericPrice = parseFloat(price);
  const formattedPrice = numericPrice.toLocaleString('en-NG');
  
  return `₦${formattedPrice}`;
};

// Function to convert USD to NGN (you can adjust the rate as needed)
export const convertUSDToNGN = (usdPrice) => {
  if (!usdPrice || isNaN(usdPrice)) return 0;
  
  // Current exchange rate (you can update this or make it dynamic)
  const exchangeRate = 1500; // 1 USD = 1500 NGN (approximate)
  return usdPrice * exchangeRate;
}; 